import * as yup from 'yup';

export const lineItemFormSchema = yup.object({
  statementSettlementAndFeeCategoryDefinitionId: yup.string().required('This is required'),
});
